import React, { useContext } from "react";
import PageTransion from "../../Componinets/PageTransion";
import { CartContext } from "../../Componinets/Context/CartContext";
import Product from "../../Componinets/Slideproduct/Product";

function Favorites() {
  let { favorites } = useContext(CartContext);
  return (
    <PageTransion>
      <div className="category_Prodicts favorites">
        <div className="Container">
          <div className="top_slide">
            <h2>Your Favorites: {favorites.length}</h2>
          </div>
          {favorites.length === 0 ? (
            <p>No Favorites Prodictes Yet.</p>
          ) : (
            <div className="Prodicts">
              {favorites.map((item) => (
                <Product item={item} key={item.id} />
              ))}
            </div>
          )}
        </div>
      </div>
    </PageTransion>
  );
}

export default Favorites;
